import styled, { css } from 'styled-components';

const NavButtonCss = css`
  color: ${({ theme }) => theme.colors.WHITE};
  padding: 0;
  height: 48px;
  width: 48px;
  border-radius: 50%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.48);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  z-index: 100;

  &:hover {
    background-color: rgba(0, 0, 0, 0.44);
  }
`;

export const Previous = styled.button`
  ${NavButtonCss};
  left: ${({ theme }) => theme.spacing.M16};
`;

export const Next = styled.button`
  ${NavButtonCss};
  right: ${({ theme }) => theme.spacing.M16};
`;
